import ThemesHelper from '@/helpers/ThemesHelper';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    hideNavigation: {
      type: Boolean,
      default: false,
    },
    selectedStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      totalSteps: ThemesHelper.getThemeParams('totalSteps'),
    };
  },
});
